<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-14 18:23:36
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2021-02-02 14:55:21
 * @Description: 布局组件，使用 a-card 渲染
 -->
<template>
  <div class="wg-card"
    v-if="!options.hidden">
    <a-collapse defaultActiveKey="1"
      :bordered="false"
      :data-model="fieldName"
      :class="options.customClass">
      <a-collapse-panel class="no-border"
        :showArrow="false"
        :header="label"
        key="1">
        <wgList :list="widget.list"
          :lang="lang">
          <template v-for="key in formSlotsKeys"
            v-slot:[key]="slotProps">
            <slot :name="key"
              v-bind="slotProps"></slot>
          </template>
        </wgList>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>
<script>
import baseMixin from '../lib/baseMixin';

export default {
  name: 'wgCard',
  mixins: [baseMixin],
  data() {
    return {
      options: {
        size: 'small',
        customClass: '',
        hidden: false,
        remoteFunc: '',
        remoteOption: '',
      },
    };
  },
  computed: {
    formSlotsKeys() {
      if (this.formContext) {
        return Object.keys(this.formContext.formSlots);
      }
      return [];
    },
  },
};
</script>
